import { Button, DialogActions } from '@mui/material'

const ConfirmationFooter = ({
  onConfirmSlot,
  isBookingLoading,
  bookingFormData,
  selectedDate,
}) => (
  <DialogActions sx={{ padding: '16px', flexDirection: 'column', gap: '0px' }}>
    <div
      style={{ display: 'flex', gap: '12px', justifyContent: 'center', marginTop: '16px' }}
    >
      <Button
        variant="contained"
        color="emrPrimary"
        onClick={onConfirmSlot}
        size="large"
        style={{ minWidth: '150px' }}
        disabled={isBookingLoading || !bookingFormData?.fee}
      >
        {isBookingLoading ? 'Booking...' : 'Confirm & Send Payment Link'}
      </Button>
    </div>

    <div
      style={{
        textAlign: 'center',
        fontSize: '12px',
        color: '#999',
        marginTop: '20px',
        fontStyle: 'italic',
      }}
    >
      ⚠️ Note: A payment link will be sent to the patient for{' '}
      {selectedDate?.format('DD/MM/YYYY')}
    </div>
  </DialogActions>
)

export default ConfirmationFooter 